import styles from './index.module.sass';

const Loading = () => {
  return (
    <div className={styles.wrapper}>
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-[hsl(var(--border))] border-t-[hsl(var(--primary))]" />
    </div>
  );
};

export default Loading;
